export default "__VITE_ASSET__Bb4PgXTX__"